import type { MDSIconKind } from "@/mds/components/icon";
import type { ButtonProps } from "react-aria-components";

export enum MDSCardVariant {
  Default = "default",
  Chrome = "chrome",
}

export enum MDSCardSlotName {
  RightAddon = "rightAddon",
  Content = "content",
}

export interface IMDSCardProps extends ButtonProps {
  variant?: MDSCardVariant;

  /**
   * Icon kind to display
   */
  mdsIcon?: MDSIconKind | (() => React.ReactNode);

  /**
   * Card title
   */
  title?: string;

  /**
   * Card description text
   */
  description?: string;

  className?: string;

  children?: React.ReactNode;
}
